import { h, Component } from 'preact';

import style from '../../style/divider.sass';

export default class Divider extends Component {
  render(props, state) {
    const dividerStyle = [];
    const dividerInnerStyle = [];
    if(props.brand === 'friedrich'){
      return null;
    }if(props.brand === 'ruud'){
      dividerStyle.push(style.dividerRuud);
      if(props.campaignType === 'repair'){
        dividerStyle.push(style.dividerRuudRepair);
      }
    }else{
      dividerStyle.push(style.smileDivider);
      dividerInnerStyle.push(style.smileDividerInner);
      if(props.campaignType === 'repair'){
        dividerStyle.push(style.smileDividerRepair);
        dividerInnerStyle.push(style.smileDividerInnerRepair);
      }
    }
    return (
      <div id="smile-divider" className={style.container}>
        <svg className={style.clipPath}>
          <clipPath id="smile-path" clipPathUnits="objectBoundingBox">
            <path d="
              M 0, 0
              C .25, .8 .75, .8, 1, 0
              L 1, 1.1
              L 0, 1.1
            "/>
          </clipPath>
        </svg>
        <svg className={style.clipPath}>
          <clipPath id="smile-path-inner" clipPathUnits="objectBoundingBox">
            <path d="
              M 0, .2
              C .25, 1 .75, 1, 1, .2
              L 1, 1.1
              L 0, 1.1
            "/>
          </clipPath>
        </svg>
        <div className={dividerStyle.join(' ')}><div className={dividerInnerStyle.join(' ')}></div></div>
      </div>
    );
  }
}
